import React, { useState } from 'react';
import { List, RefreshIconButton, useListController, useRefresh } from 'react-admin';
import { useMediaQuery, makeStyles, FormControl, InputLabel, Select, Menu, MenuItem, IconButton, TextField as MuiTextField, Button, Dialog, DialogActions, CircularProgress } from '@material-ui/core';
import { customTheme } from "./customTheme";
// import moment from 'moment'
import { useLocation } from 'react-router-dom';
import CustomPagination from './components/CustomPagination';
import ParkingSearchSelector from './components/ParkingSearchSelector';
import CustomSearch from './components/CustomSearch';
import config from "./config.json";
import CustomDateTimePicker from "./components/CustomDateTimePickerV4";
import moment from 'moment';
import EditIcon from '@material-ui/icons/Edit';
import notify from './components/CustomUseNotify';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';

const useStyles = makeStyles({
    list: {
        marginBottom: 0,
    },
    loaderContainer: {
        display: "flex",
        flex: 1,
        alignItems: "center",
        justifyContent: "center",
    },
    parkingSelectorContainer: {
        display: "grid",
        justifyContent: "space-between",
    },
    chipCell: {
        textAlign: "center",
        padding: customTheme.spacing(1, 2),
        display: "inline-block",
        borderRadius: 50,
        minWidth: 100,
    },
    dialogPaper: {
        borderRadius: 15,
        padding: "5px 25px 5px",
    },
    backDrop: {
        backgroundColor: "#00000042"
    },
});

export const FloorOccupancy = (props) => {
    // const refresh = useRefresh();
    const classes = useStyles();
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const location = useLocation();

    const [listData, setListData] = useState([])
    const [allRecords, setAllRecords] = useState([])
    const [showFilter] = useState(sessionStorage.getItem("show_filter") === "1");
    let prevSearch = sessionStorage.getItem(location.pathname) ? JSON.parse(sessionStorage.getItem(location.pathname)) : ""
    const [currentParking, setCurrentParking] = useState(prevSearch.currentParking ? prevSearch.currentParking : {});
    const zoneIds = currentParking.zone_ids ? currentParking.zone_ids.split(",") : null;
    const zoneLabels = currentParking.zones ? currentParking.zones.split(";") : null;
    const finalZones = zoneIds && zoneLabels ? zoneIds.map((id, index) => (
        { id, name: zoneLabels[index] }
    )) : null;
    if (finalZones)
        finalZones.sort((a, b) => (a.name > b.name ? 1 : (a.name < b.name ? -1 : 0)));

    const [search, setSearch] = useState(prevSearch.inputSearch)
    let searchTypeState = ["Name"]
    const [searchTypes, setSearchTypes] = useState(prevSearch.type ? prevSearch.type : "Name");
    const [startDateTime, setStartDateTime] = useState(null);
    const [endDateTime, setEndDateTime] = useState(null);

    const filter = { search: { value: search ? search : "", type: searchTypes ? searchTypes : "" }, access_key: currentParking.id, parking_info_id: currentParking.allZones ? currentParking.parking_info_id : undefined, start_time: startDateTime ? moment(startDateTime).format("YYYY-MM-DD HH:mm:ss") : "", end_time: endDateTime ? moment(endDateTime).format("YYYY-MM-DD HH:mm:ss") : "" };

    const onParkingChange = (parking) => {
        setCurrentParking({ ...parking, allZones: true });
    };

    const onZoneChange = (event) => {
        setCurrentParking({
            ...currentParking,
            id: event.target.value,
            name: zoneLabels[zoneIds.findIndex(id => id === event.target.value)],
            allZones: event.target.value === "All"
        });
    };

    // useEffect(() => {
    //     socket.on('connnection', () => {
    //         console.log('connected to server');
    //     })
    //     socket.on(`PARKING_AREA_LOG`, ({ inserted_log_id }) => {
    //         refresh()
    //         setHighLightRecordIds((prev) => {
    //             return { ...prev, [inserted_log_id]: inserted_log_id }
    //         })
    //         setTimeout(() => {
    //             setHighLightRecordIds((prev) => {
    //                 const records = { ...prev };
    //                 delete records[inserted_log_id];
    //                 return records
    //             })
    //         }, 5000);
    //     })

    //     socket.on('message', (message) => {
    //         console.log(message);
    //     })

    //     socket.on('disconnect', () => {
    //         console.log('Socket disconnecting');
    //     })

    // }, [])// eslint-disable-line react-hooks/exhaustive-deps

    React.useEffect(() => {
        setAllRecords((prev) => {
            let temp = Object.keys(listData).length !== 0 ? [...Object.values(listData)].reverse() : []
            console.log(temp.reverse())
            return temp
        })
    }, [listData])

    return (
        <div>
            <div className={classes.parkingSelectorContainer} style={{ gridAutoFlow: isSmallDevice ? "row" : "column", gridTemplateColumns: isSmallDevice ? "100%" : "48% 48%", gridRowGap: isSmallDevice ? 18 : 0, margin: 0 }}>
                {showFilter &&
                    <ParkingSearchSelector
                        value={currentParking}
                        onChange={onParkingChange}
                        clearable={true}
                        pathName={location.pathname}
                    />
                }

                {currentParking.zone_ids && currentParking.zone_ids.includes(',') &&
                    <FormControl variant="outlined" style={{ marginTop: isSmallDevice ? 0 : 10 }}>
                        <InputLabel>Zone Name</InputLabel>
                        <Select
                            value={currentParking.allZones ? "All" : currentParking.id}
                            onChange={onZoneChange}
                            label="Zone Name"
                            variant="outlined"
                        >
                            <MenuItem value="All">All</MenuItem>
                            {finalZones.map((zone, index) => (
                                <MenuItem key={index} value={zone.id}>{zone.name}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                }
            </div>
            <div className='customStyleForDataSearchDiv'>
                <CustomSearch search={search} setSearch={setSearch} searchTypes={searchTypes} setSearchTypes={setSearchTypes} searchTypeState={searchTypeState} pathName={location.pathname} />
                <CustomDateTimePicker startDateTime={startDateTime} setStartDateTime={setStartDateTime} endDateTime={endDateTime} setEndDateTime={setEndDateTime} />
                <RefreshIconButton size={25} color="primary" />
            </div>

            {startDateTime && endDateTime && (
                <List {...props}
                    className="occupancyListStyle"
                    style={{ marginTop: 20 }}
                    empty={false}
                    filter={filter}
                    title="Floor Occupancy"
                    bulkActionButtons={false}
                    exporter={false}
                    actions={false}
                    pagination={<CustomPagination setListData={(listData) => setListData(listData.data)} trackUpdatedListData={true} />} >
                    <div>
                        {allRecords[0] && allRecords.map((record) => {
                            return <FloorOccupancyCard record={record} />
                        })}
                    </div>
                </List>
            )}
        </div>
    )
};

const FloorOccupancyCard = ({ record }) => {
    const refresh = useRefresh();
    const [showFilter] = useState(sessionStorage.getItem("show_filter") === "1");
    const [settingsMenu, setSettingsMenu] = useState({});
    const [occupancyDetails, setOccupancyDetails] = useState(null)

    const openSettingsMenu = (event) => {
        event.preventDefault();
        setSettingsMenu({ mouseX: event.clientX - 2, mouseY: event.clientY - 4 })
    };
    const closeSettingsMenu = () => {
        setSettingsMenu({});
    };

    const openDialog = (type) => {
        if (type === 1) setOccupancyDetails({ title: "Occupancy", dialogText: `What is the Occupancy of ${record.name} at this moment`, urlPath: `/crm/v3/parkingAreas/${record.id}`, paramsKeyName: "occupancy" })
        if (type === 2) setOccupancyDetails({ title: "Parking Spots", dialogText: `Total occupancy at ${record.name}`, urlPath: `/crm/v3/parkingAreas/${record.id}`, paramsKeyName: "total_occupancy" })
        closeSettingsMenu()
    }

    const clearOccupancyDetails = () => {
        setOccupancyDetails(null)
    }

    const occupancy = record.entry_count === 0 && record.exit_count === 0 && record.occupancy_count > 0 ? record.occupancy_count : record.occupancy > 0 ? record.occupancy : 0
    const parkingSpots = record.total_occupancy > 0 ? record.total_occupancy : 0
    return (
        <>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', borderRadius: 5, border: "1px solid #C2CFE0", padding: "16px 16px", marginBottom: 20, flexWrap: "wrap", columnGap: 10, rowGap: 10 }}>
                {showFilter &&
                    <div>
                        <div style={{ color: "#334D6E", fontSize: 16, fontWeight: 600, width: "300px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{record.parking_name}</div>
                        <div style={{ color: "#334D6E", fontSize: 12, fontWeight: 600 }}>{record.name}</div>
                    </div>
                }

                <div>
                    <div style={{ color: "#334D6E", fontSize: 12, marginBottom: 7 }}>Entered</div>
                    <div style={{ color: "#334D6E", fontSize: 14, fontWeight: 600 }}>{record.entry_count > 0 ? record.entry_count : "-"}</div>
                </div>
                <div>
                    <div style={{ color: "#334D6E", fontSize: 12, marginBottom: 7 }}>Exited</div>
                    <div style={{ color: "#334D6E", fontSize: 14, fontWeight: 600 }}>{record.exit_count > 0 ? record.exit_count : "-"}</div>
                </div>
                <div>
                    <div style={{ color: "#334D6E", fontSize: 12, marginBottom: 7 }}>Occupancy</div>
                    <div style={{ color: "#334D6E", fontSize: 14, fontWeight: 600 }}>
                        {occupancy}/{parkingSpots}
                    </div>
                </div>
                <div style={{ marginTop: -7 }}>
                    <div style={{ color: "#D3D8DD", fontSize: 12, visibility: "hidden" }}>Settings</div>
                    <IconButton size='small' onClick={(e) => openSettingsMenu(e)} style={{ color: "#334D6E" }}><MoreHorizIcon /></IconButton>
                </div>
            </div>
            <Menu
                anchorReference="anchorPosition"
                anchorPosition={settingsMenu.mouseY !== null && settingsMenu.mouseX !== null ? { top: settingsMenu.mouseY, left: settingsMenu.mouseX } : { top: 0, left: 0 }}
                keepMounted
                open={Boolean(settingsMenu.mouseX)}
                onClose={closeSettingsMenu}
            >
                <MenuItem onClick={() => openDialog(2)}>Edit Total Occupancy</MenuItem>
                <MenuItem onClick={() => openDialog(1)}>Edit Occupancy</MenuItem>
            </Menu>

            {occupancyDetails && <UpdateValues title={occupancyDetails.title} dialogText={occupancyDetails.dialogText} urlPath={occupancyDetails.urlPath} paramsKeyName={occupancyDetails.paramsKeyName} refresh={refresh} clearOccupancyDetails={clearOccupancyDetails} />}
        </>
    )
}

const UpdateValues = ({ title, dialogText, urlPath, paramsKeyName, refresh, clearOccupancyDetails }) => {
    const classes = useStyles();
    const [loading, setLoading] = useState(false);
    const [dialogVisible, setDialogVisible] = useState(title ? true : false);
    const [value, setValue] = useState(0);
    const closeDialog = () => {
        setDialogVisible(false)
        clearOccupancyDetails()
    }

    const updateHandler = () => {
        if ((typeof value !== "string" && typeof value !== "number") || value === "" || isNaN(value)) {
            notify("Please enter a valid number", "warning");
            return;
        }

        setLoading(true);
        const token = sessionStorage.getItem('token');
        let params = {}
        params[paramsKeyName] = value
        fetch(`${config.HOST_NAME}${urlPath}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(params)
        })
            .then(response => response.json())
            .then(json => {
                setLoading(false);
                notify(json.message, json.success ? "success" : "warning");
                if (json.success) {
                    refresh();
                    closeDialog()
                }
            })
            .catch((error) => {
                setLoading(false);
                notify(error, "warning");
            });
    };
    return (
        <>
            <Dialog
                open={dialogVisible} onClose={closeDialog} classes={{ paper: classes.dialogPaper }} BackdropProps={{ classes: { root: classes.backDrop } }}
            >
                <div style={{ width: "100%" }}>
                    <div style={{ width: "100%" }}>
                        <p style={{ fontSize: 16, color: "#444", fontWeight: "bold" }}>{dialogText}</p>
                        <MuiTextField fullWidth variant='outlined' size="small" value={value} onChange={(e) => setValue(e.target.value)} />
                    </div>
                </div>
                <DialogActions style={{ padding: "22px 0px" }}>
                    <Button onClick={closeDialog} color="error" variant='contained' style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", backgroundColor: "#E7EBF0", color: "#334D6E" }} disableElevation>
                        Cancel
                    </Button>
                    <Button onClick={updateHandler} color="contained" variant='contained' style={{ backgroundColor: '#18cc69', color: "#FFF", textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px" }} autoFocus disableElevation>
                        {loading ? <CircularProgress color="#fff" size={20} /> : "Update"}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
